export default "__VITE_ASSET__DfHyj96I__"